/**
 * unicode-offset.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

/**
 * Adjust the (Unicode) characters in a string up or down by a specified number
 * of code points.
 */
@Pipe({name: "u_offset"})
export class UnicodeOffsetPipe implements PipeTransform
{
  public static offset (value : string, offset : number = 0) : string
  {
    console.log(value.split("").map((s : string) => s.codePointAt(0) + offset));
    return String.fromCodePoint.apply(
      null,
      value.split("").map((s : string) => s.codePointAt(0) + offset)
    );
  }
  public transform (value : string, offset : number = 0) : string
  {
    if (typeof value !== "string" || value.length === 0)
    {
      return value;
    }
    return UnicodeOffsetPipe.offset(value, offset);
  }
}

/**
 * The offset between lowercase latin alphabet and the special flag combining
 * characters.
 */
const LC_ROMAN_TO_FLAG_DELTA : number = 0x1f1e6 - 0x61;

/**
 * Offset the unicode glyphs of a string such that lowercase latin letters
 * become the special combining flag emoji symbols.
 */
@Pipe({name: "flagify"})
export class FlagifyPipe implements PipeTransform
{
  public transform (value : string) : string
  {
    if (typeof value !== "string" || value.length === 0)
    {
      return value;
    }
    return UnicodeOffsetPipe.offset(
      value.toLocaleLowerCase(),
      LC_ROMAN_TO_FLAG_DELTA
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/unicode-offset.pipe.ts